import AuthSubtitle from 'src/features/auth/components/auth-subtitle'
import AuthTitle from 'src/features/auth/components/auth-title'
import GreenPawn from 'src/shared/assets/images/green-pawn.png'
import { Button } from 'src/shared/components/ui/buttons/button'
import iOSQRCode from 'src/shared/features/marketplace-instant-match/assets/QRcode.png'
import useBreakpoint from 'src/shared/hooks/use-breakpoint'

interface AuthSuccessProfessionalProps {
  title: string
  description: string
  className?: string
}

export default function AuthSuccessProfessional({ title, description, className }: AuthSuccessProfessionalProps) {
  const { isSmTabletOrSmaller } = useBreakpoint()

  const handleDownloadIOSApp = () => {
    window.open('https://apps.apple.com/us/app/the-conrad-app/id6741168192', '_blank')
  }

  return (
    <div className={className}>
      <div className="flex flex-col items-center justify-center">
        {isSmTabletOrSmaller ? (
          <div className="mx-auto mb-6 h-[120px] w-[101px] translate-x-[-10px]">
            <img src={GreenPawn} alt="Auth Success Icon" className="size-full object-contain" />
          </div>
        ) : (
          <div className="mx-auto mb-6 mt-5 size-[120px]">
            <img src={iOSQRCode} alt="Conrad iOS QR Code" className="size-full object-contain" />
          </div>
        )}
        <AuthTitle title={`${title},`} className="my-0 text-[26px] leading-none md:text-[32px]" />
        <AuthTitle title={`but you need the app!`} className="mt-0 text-[26px] md:text-[32px]" />
        <AuthSubtitle description={description} className="text-[15px] md:text-[16px]" />
        <Button
          onClick={handleDownloadIOSApp}
          className="h-[55px] w-full max-w-[380px] rounded-full text-[15px] font-semibold"
        >
          {isSmTabletOrSmaller ? 'Download App' : 'Download iOS App'}
        </Button>
        <p className="-mb-1 mt-3 text-[15px] leading-[1.6] text-primary">Android app coming this month!</p>
      </div>
    </div>
  )
}
